module.exports = __webpack_public_path__ + "static/media/badge-rapide.7e95a7b8.png";